'use strict';

import EventEmitter from 'eventemitter3';

import appStore from './AppStore';

/**
 * A wrapper for a global eventemitter3 instance.
 */
class Events {
    constructor() {
        this.ee = new EventEmitter();
    }

    /**
     * Register a listener for the given event.
     * @param event The event key.
     * @param method The callback method.
     */
    listen(event, method) {
        if (! event) {
            throw "Event key was missing.";
        }
        if (! method) {
            throw "Method was missing.";
        }
        this.ee.on(event, method);
    }

    /**
     * Emit an event.
     * @param event The event key.
     * @param value The param that will be pass to the callback.
     */
    emit(event, value) {
        if (! event) {
            throw "Event key was missing.";
        }
        this.ee.emit(event, value);
        if (appStore.isDebug()) {
            let v = value;
            if (typeof value === "object" ) {
                v = JSON.stringify(value);
            }
        }
    }

    /**
     * Removes an even listener.
     * @param event The even key.
     * @param method The callback method.
     */
    remove(event, method) {
        this.ee.removeListener(event, method);
    }
}

export default new Events();